import { render } from "./XIconSolidDesktop.vue?vue&type=template&id=1bcaee61"
import script from "./XIconSolidDesktop.vue?vue&type=script&lang=js"
export * from "./XIconSolidDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidDesktop.vue"]])

export default __exports__